module.exports = __webpack_public_path__ + "static/img/A6405Test.1045d7d8.png";